// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulputpp{gap:var(--ds-space-150,9pt)}._18m91wug{overflow-y:auto}\n._19pkxncg{margin-top:var(--ds-space-800,4pc)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1reo1wug{overflow-x:auto}\n._1ul91osq{min-width:100%}\n._2lx21bp4{flex-direction:column}\n._4cvr1h6o{align-items:center}", ""]);
// Exports
module.exports = exports;
